const personsaccount = {
	name: '',
	icon: '',
	fields: {
		hp_id: 'ID',
		lastname: 'Person',
		tos: 'Nutzungsbedingungen',
		privacy: 'Datenschutz',
		user: {
			email: 'E-Mail',
			logins_count: 'Logins',
			last_login: {
				created_at: 'Letzte Anmeldung',
			},
		},
		created_at: 'Erstellt',
	},
}

export default personsaccount
